import { CognitoUserPool } from 'amazon-cognito-identity-js'
const poolData = {
  UserPoolId: process.env.NODE_ENV === 'development' ? 'eu-central-1_XSg71Kju0' : 'eu-central-1_gFSYW5HWp',
  ClientId: process.env.NODE_ENV === 'development' ? '99o7046pknklngru096r453ia' : '7ovnl8i8ggq54rasjcf4tmjt03',
}

export default new CognitoUserPool(poolData)
